<template>
    <div class="container">

        <Backlink :back="{ name: 'clients' }" />
        <h2 class="text-muted">Informations du client</h2>
        <h3> {{ client.nom }} {{ client.prenoms }}</h3>

        <section-container>
            <p class="fw-bold">Informations personnelles:</p>
            <div class="col">
                <p><strong>Phone:</strong> {{ client.telephone }} <span v-if="client.telephone2"> / {{
                    client.telephone2 }}</span></p>
                <p><strong>Adresse:</strong> {{ client.adresse }}</p>
                <p><strong>Genre:</strong> {{ client.genre }}</p>
                <p class="text-end">
                    <button class="btn btn-primary"
                        @click="$router.push({ name: 'clients.edit', params: { id: client.id } })">Modifier</button>
                </p>
            </div>
        </section-container>

        <section-container marquage>
            <div class="mb-3">
                <div class="d-flex justify-content-between">
                    <p class="fw-bold">Mesures:</p>
                    <button class="btn btn-primary"
                        @click="$router.push({ name: 'measurements.create', params: { client_id: client.id } })">Ajouter</button>
                </div>

            </div>
            <div class="col">
                <div class="col">
                    <select v-if="client.mesures && client.mesures.length" class="form-select"
                        aria-label="Default select example" @change="selectMesure($event.target.value)"> >
                        <option selected="">-- Sélectionner une mesure --</option>
                        <option v-for="m in client.mesures" :key="m.id" :value="m.id">
                            {{ m.label }} - {{ formatDate(m.created_at) }}
                        </option>
                    </select>
                    <select v-else class="form-select" aria-label="Default select example" disabled>
                        <option>Aucune mesure enregistrée.</option>
                    </select>
                </div>

                <div v-if="selectedMeasure.id" class="col mt-3">
                    <h5>{{ selectedMeasure.label }} ({{ formatDate(selectedMeasure.created_at) }})
                    </h5>
                    <div class="row">
                        <div class="row">
                            <div class="col-12 text-end">
                                <button class="btn btn-secondary mb-2"
                                    @click="$router.push({ name: 'measurements.edit', params: { id: selectedMeasure.id, client_id: client.id } })">
                                    <span><i class="bi bi-pencil-square me-1"></i></span>
                                    Modifier
                                    la mesure</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 col-5 border border-1 rounded p-2 m-1"
                                v-for="m in selectedMeasure.mesures_data" :key="m.short">
                                <div>
                                    <p class="fw-bold">{{ m.label }}</p>
                                </div>
                                <div class="align-items-end d-flex d-flex justify-content-between align-items-end">
                                    <p class="text-muted"> {{ m.short }}</p>
                                    <p class="fw-bold fs-2 border border-1 rounded p-1">{{ m.value }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section-container>

        <section-container marquage>
            <div class="mb-3">
                <div class="d-flex justify-content-between">
                    <p class="fw-bold">Modèles:</p>
                    <button class="btn btn-primary"
                        @click="$router.push({ name: 'models.create', params: { client_id: client.id } })">Ajouter</button>
                </div>
            </div>
            <div v-if="client.styles">
                <div class="row">
                    <div class="col-12 col-md-4 mb-3" v-for="style in client.styles" :key="style.id">
                        <div class="card model-card h-100 border-0 shadow-sm">
                            <img :src="getStyleImage(style)" class="card-img-top model-card-img" :alt="style.label" />
                            <div class="card-body">
                                <h5 class="card-title">{{ style.label }}</h5>
                                <p class="card-text"> <span class="text-muted text-sm">Statut</span> <span
                                        :class="['badge', statusInfo[style.status]?.class]"> {{
                                            statusInfo[style.status]?.label }}</span></p>
                                <p class="card-text">
                                    <span class="text-muted text-sm"> Prochain RDV: </span>
                                    <span v-if="style.next_rdv?.length && style.status != modelStatus.DELIVERED">{{
                                        formatDate(style.next_rdv) }}</span>
                                    <span v-else>Aucun rendez-vous</span>
                                </p>
                                <p class="text-end">
                                    <button class="btn btn-primary"
                                        @click="$router.push({ name: 'models.view', params: { id: style.id } })">Voir le
                                        modèle</button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section-container>
    </div>
</template>

<script>

import Backlink from '@/components/partials/Backlink.vue';
import dateFormater from '@/helpers/dateFormater';
import { ModelStatus, modelStatusInfo } from '@/enums/ModelStatus';
import SectionContainer from '@/components/elements/SectionContainer.vue';
import defaultImage from '@/assets/default.png';

export default {
    name: 'ClientView',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    components: {
        Backlink,
        SectionContainer
    },
    data() {
        return {
            client: {},
            selectedMeasure: {},
            statusInfo: modelStatusInfo,
            modelStatus: ModelStatus
        }
    },
    watched: {
        "selectedMeasure.id"(newMeasureId) {
            console.log("Selected measure changed ii:", newMeasureId);
            this.selectMesure(newMeasureId);
        }
    },
    methods: {
        ...dateFormater,
        getClient() {
            this.$api.get(`/clients/${this.id}`)
                .then(response => {
                    this.client = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the client!', error);
                });
        },
        selectMesure(measureId) {
            this.selectedMeasure = this.client.mesures.find(m => m.id == measureId) || {};
        },
        getStyleImage(style) {
            const imagePath = style.image_path || style.image || style.photo || style.image_url;
            if (imagePath) {
                return this.$api.defaults.assetsBaseURL + imagePath;
            }
            return defaultImage;
        }
    },
    created() {
        this.getClient();
    }
}

</script>

<style scoped>
.model-card-img {
    height: 150px;
    object-fit: cover;
}

.model-card {
    border: 1px solid rgba(106, 74, 166, 0.2);
    background: #ffffff;
}

.model-card .card-body {
    padding: 0.9rem;
}

.model-card .card-title {
    color: #5c3f93;
    font-weight: 700;
}
</style>
